import React from 'react';
import FarmGallery from './FarmGallery';

export default function OurStory() {
  return (
    <section id="aboutus" className="py-20 lg:py-28 relative overflow-hidden">

      <div className="container mx-auto px-4 lg:px-8 relative z-10">
        <div className="max-w-6xl mx-auto mb-16">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-clay mb-4">Our Story</p>
          <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-gray-900 mb-6">
            Meet Mubarak Farm
          </h2>
          <p className="text-lg text-gray-700 max-w-2xl leading-relaxed">
            Since 2018, Mubarak Farm has grown <strong className="text-gray-900">Moonshine Coffee</strong> in Nabutaka, Luweero District, Uganda. We handle every stage from cultivation to export.
          </p>
        </div>

        {/* Main Content Grid */}
        <div className="max-w-6xl mx-auto mb-20">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">

            {/* Left Column - Farm Details */}
            <div className="space-y-8">
              <div>
                <h3 className="font-heading text-3xl lg:text-4xl text-gray-900 mb-4">Direct from farm to cup</h3>
                <p className="text-lg text-gray-700 leading-relaxed mb-4">
                  Located in Nabutaka Township, Luweero District, our family-owned farm sits on some of Uganda's most fertile agricultural land. The region's soil, altitude and steady rainfall suit Robusta well.
                </p>
                <p className="text-lg text-gray-700 leading-relaxed">
                  Unlike brokers and middlemen, we own and operate every step of production. This vertical integration means fresher coffee, complete traceability, and direct relationships with our customers across East Africa and Pakistan.
                </p>
              </div>

              {/* Key stats as a divided list, not boxed cards */}
              <dl className="grid grid-cols-2 gap-x-8 border-t border-gray-300/70">
                <div className="flex flex-col py-5 border-b border-gray-300/70">
                  <dt className="text-sm text-gray-600 mt-2">Established</dt>
                  <dd className="font-heading text-4xl text-clay leading-none order-first">2018</dd>
                </div>
                <div className="flex flex-col py-5 border-b border-gray-300/70">
                  <dt className="text-sm text-gray-600 mt-2">Robusta</dt>
                  <dd className="font-heading text-4xl text-clay leading-none order-first">100%</dd>
                </div>
                <div className="flex flex-col py-5 border-b border-gray-300/70">
                  <dt className="text-sm text-gray-600 mt-2">Screen sizes</dt>
                  <dd className="font-heading text-4xl text-clay leading-none order-first">12/15/18</dd>
                </div>
                <div className="flex flex-col py-5 border-b border-gray-300/70">
                  <dt className="text-sm text-gray-600 mt-2">Moisture content</dt>
                  <dd className="font-heading text-4xl text-clay leading-none order-first">11.8%</dd>
                </div>
              </dl>
            </div>

            {/* Right Column — Commitments as typographic list with numerals */}
            <div>
              <h3 className="font-heading text-3xl lg:text-4xl text-gray-900 mb-8">Our commitment</h3>
              <ol className="divide-y divide-gray-300/70 border-y border-gray-300/70">
                <li className="flex gap-5 py-6">
                  <span className="w-14 flex-shrink-0 font-heading text-clay text-3xl leading-none">01</span>
                  <div className="flex-1 min-w-0">
                    <h4 className="font-bold text-xl text-gray-900 mb-1">Hand sorted, three grades</h4>
                    <p className="text-gray-700 leading-relaxed">Beans graded across Screen 12, 15, and 18. No additives. Each grade is uniform within itself, so roasters get predictable extraction at every tier.</p>
                  </div>
                </li>
                <li className="flex gap-5 py-6">
                  <span className="w-14 flex-shrink-0 font-heading text-clay text-3xl leading-none">02</span>
                  <div className="flex-1 min-w-0">
                    <h4 className="font-bold text-xl text-gray-900 mb-1">Local labour, end to end</h4>
                    <p className="text-gray-700 leading-relaxed">From planting to packaging, every step is done by people who live in Nabutaka. Skills training pays forward.</p>
                  </div>
                </li>
                <li className="flex gap-5 py-6">
                  <span className="w-14 flex-shrink-0 font-heading text-clay text-3xl leading-none">03</span>
                  <div className="flex-1 min-w-0">
                    <h4 className="font-bold text-xl text-gray-900 mb-1">Traceable to the drying bed</h4>
                    <p className="text-gray-700 leading-relaxed">Every batch links back to its row, harvest date, and raised-bed station. Ask, and we'll send you the paperwork.</p>
                  </div>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>

      <FarmGallery />
    </section>
  );
}
